import { getJSON, HOST } from './ultile';
import globalConfig from '../utiles/globalConfig';

export let ERR_CODE = '0';
export const SERVICE_CONFIGED = 1;
export const LOAD_SERVICE_STATUS = 'loadServiceStatus';
export const SET_SERVICE_STATUS = 'setServiceStatus';

let loadded = false;

export default {
  state: {
    privacyStatus: true,
    serviceStatus: true,
    haveTwoService: true,
  },
  mutations: {
    [SET_SERVICE_STATUS](state, status) {
      const CONFIED_CODE = 1;
      state.privacyStatus = status.privacy_terms == CONFIED_CODE;
      state.serviceStatus = status.server_terms == CONFIED_CODE;
      state.haveTwoService =
        status.privacy_terms == CONFIED_CODE &&
        status.server_terms == CONFIED_CODE;
    },
  },
  actions: {
    [LOAD_SERVICE_STATUS]({ commit }, gameId) {
      if (loadded) {
        return;
      }
      const ACTION = `${HOST}sdkInit/userCenterTerms`;
      const GAME_ID = gameId || globalConfig.getHrefParamUndecode('gameId');
      getJSON(ACTION, {
        gameId: GAME_ID,
      }).then(({ errmsg, data }) => {
        if (errmsg === '') {
          commit(SET_SERVICE_STATUS, data);
        }
      });
      loadded = true;
    },
  },
};
